<template>
  <div class="body">
    <div class="form bg-white p20 mb30">
      <el-form ref="form" @submit.native.prevent :model="listParams" label-width="80px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试名称" prop="examName">
              <el-input
                v-model="listParams.examName"
                placeholder="请输入考试名称"
                @keyup.enter.native="search" clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="考试类型" prop="examType">
              <el-select
                v-model="listParams.examType"
                placeholder="请选择考试类型"
              >
                <el-option
                  :label="item.text"
                  :value="item.code"
                  v-for="(item, index) in examTypeList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考试时间" prop="date">
              <el-date-picker
                v-model="listParams.date"
                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="searchBut">
          <el-form-item>
            <!-- <el-button type="primary">导出</el-button> -->
            <el-button type="primary" @click="search"
            >搜索</el-button
            >
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="bg-white p20 pb50">
      <el-table
        class="mb20"
        v-loading="loading"
        element-loading-text="拼命加载中"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="考试名称" prop="examName"></el-table-column>
        <el-table-column label="考试时间" prop="startTime"></el-table-column>
        <el-table-column label="考试类型" prop="examTypeString">
        </el-table-column>
        <el-table-column
          label="应参加考试人数"
          prop="peopleNumber"
        ></el-table-column>
        <el-table-column
          label="实际考试人数"
          prop="sexamNumber"
        ></el-table-column>
        <el-table-column
          label="合格人数"
          prop="qualifiedNumber"
        ></el-table-column>
        <el-table-column label="合格率" prop="passRate"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              @click="jumpDetail(scope.row.id)"
            >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float:right;"
        background
        layout="total ,prev, pager, next"
        :total="total"
        :current-page="listParams.page"
        :page-size="listParams.pageSize"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import exam from "../../api/new/exam.js";
export default {
  data() {
    return {
      questionTypeList: [], // 题型列表
      tableData: [],
      examTypeList: [],

      listParams: {
        page: 1,
        pageSize: 15,
        examName: "",
        date: "",
        examType: ""
      },
      total: 0,
      loading: true
    };
  },
  mounted() {
    this.examTypeList = JSON.parse(localStorage.getItem("exam_type"));
    this.search();

  },
  methods: {
    search() {
      this.$set(this.listParams, 'page', 1);
      this.trainingStatisticsList();
    },
    trainingStatisticsList() {
      let listParams = {
        ...this.listParams,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      !listParams.examName && delete listParams.examName;
      !listParams.examType && delete listParams.examType;
      if (listParams.date && listParams.date.length) {
        listParams.startTime = listParams.date[0];
        listParams.endTime = listParams.date[1];
        delete listParams.date;
      } else {
        delete listParams.date;
      }
      this.loading = true;
      exam.trainingStatisticsList(listParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;

          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        }
      });
    },
    pageChange(e) {
      this.listParams.page = e;
      this.trainingStatisticsList();
    },
    jumpDetail(id) {
      this.$router.push({
        path: "/examination/examStatisticsDetail",
        query: { id }
      });
    },

    /**
     * 重置表单
     */
    resetForm(formName) {
      console.log(1);
      this.$refs[formName].resetFields();
      this.search();
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/pages/examination/examStatistics.vue